import { render, staticRenderFns } from "./transactionRecords.vue?vue&type=template&id=9b5c3442&scoped=true"
import script from "./transactionRecords.vue?vue&type=script&lang=js"
export * from "./transactionRecords.vue?vue&type=script&lang=js"
import style0 from "./transactionRecords.vue?vue&type=style&index=0&id=9b5c3442&prod&scoped=true&lang=css"
import style1 from "./transactionRecords.vue?vue&type=style&index=1&id=9b5c3442&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5c3442",
  null
  
)

export default component.exports